import { filterQueryParametersAndReplace, getWhitelistedQuery } from 'utils/url';
import { verifyRequiredBetaFeatures } from 'utils/betaFeatures/verifyRequiredBetaFeatures';
import { BetaFeatures } from 'apps/staticContent/consts';
import { msg } from 'api';

const getSiteId = location => {
  const { siteId } = location.query;
  if (Array.isArray(siteId)) {
    return siteId[0];
  }
  return siteId;
};

const redirectTo = (nextState, replace) => {
  const contentSiteId = getSiteId(nextState.location);
  if (contentSiteId) {
    replace({
      pathname: `/content/${contentSiteId}`,
      query: getWhitelistedQuery(nextState.location.query),
      state: {
        isCatalogueRedirect: true,
      },
    });
  } else {
    replace('/not-found');
  }
};

export default [
  {
    path: 'getStaticContent(.do)(.go)',
    onEnterHandlers: [
      redirectTo,
    ],
  },
  {
    path: 'scontent/customerServicesFAQ',
    onEnterHandlers: [
      verifyRequiredBetaFeatures([BetaFeatures.NEW_HELP_FAQ]),
      filterQueryParametersAndReplace(msg.staticContent.faqRedirectionLink),
    ],
  },
];
